<template>
  <div class="wrap">
    <div class="left">
      <el-tree
        :style="{ 'margin-top': treeData.length == 0 ? '40%' : '' }"
        v-loading="treeLoading"
        ref="mTree"
        :data="treeData"
        show-checkbox
        default-expand-all
        check-strictly
        check-on-click-node
        :expand-on-click-node="false"
        node-key="code"
        @check="treeCheck"
      />
    </div>
    <div class="right">
      <div class="btn">
        <el-button
          type="primary"
          style="margin: 0 0 20px"
          @click="submit"
          :loading="submitLoading"
          >提交分解</el-button
        >
      </div>
      <m-table ref="mTable" :request="requestEdit"></m-table>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
import { ElMessage } from "element-plus";
function debounce(fn, sec) {
  let v = "";
  return function (...arg) {
    let _this = this;
    if (v) {
      clearTimeout(v);
    }
    v = setTimeout(() => {
      fn.call(_this, ...arg);
    }, sec);
  };
}
export default {
  name: "cutBox",
  data() {
    return {
      taskid: "",
      requestEdit: {
        table: {
          requestWay: "postAction",
          url: "budget/task/break/select",
        },
      },
      treeLoading: false,
      submitLoading: false,
      treeData: [],
    };
  },
  methods: {
    init(id) {
      this.$refs.mTable.resetTable();
      this.taskid = id;
      this.treeData = [];
      this.treeLoading = true;
      setTimeout(() => {
        getAction("budget/task/break/getSubDept", {
          taskid: this.taskid,
        })
          .then((res) => {
            if (res.code == 200) {
              this.treeData = res.data;
            } else {
              if (res.message || res.msg) ElMessage.error(res.message || res.msg);
            }
          })
          .finally(() => {
            this.treeLoading = false;
          });
      }, 300);
    },
    treeCheck: debounce(function (a, b) {
      let deptcodes = b.checkedKeys;
      if (deptcodes.length == 0) {
        this.$refs.mTable.resetTable();
        return;
      }
      this.$refs.mTable.init({ deptcodes }, [
        {
          type: "select",
          url: "base/dept/dept/getDeptMember",
          method: "getAction",
          edit: 3,
          params: [
            {
              key: "deptcode",
              source: "deptcode",
            },
          ],
        },
      ]);
    }, 700),
    submit() {
      let arr = this.$refs.mTable.getTableData();
      if (arr.length == 0) {
        ElMessage.error("请选择部门确定要分解的数据");
        this.$refs.mTable.cutStop();
        return;
      }
      let data = [];
      arr.forEach((item) => {
        let temp = [];
        item.data.forEach((val) => {
          if (!Array.isArray(val)) {
            temp.push(val);
          }
        });
        data.push(temp);
      });
      let params = {
        taskid: this.taskid,
        data,
      };
      this.submitLoading = true;
      postAction("budget/task/break/break", params)
        .then((res) => {
          if (res.code == 200) {
            if (res.message || res.msg)
              ElMessage({
                message: res.message || res.msg,
                type: "success",
              });
            this.$emit("CutOk");
          } else {
            if (res.message || res.msg) ElMessage.error(res.message || res.msg);
          }
        })
        .finally(() => {
          this.$refs.mTable.cutStop();
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a7bbdd;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
.wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 70vh;
}
.left {
  width: 25%;
  height: 100%;
  margin: 0 5% 0 0;
  overflow: auto;
  padding: 20px 0;
  box-sizing: border-box;
}
.right {
  width: 70%;
  height: 100%;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
